import ManageTeam from 'modules/settings/management/manage-team/components/ManageTeam';
import ManageTeamWrapper from 'modules/settings/management/manage-team/Main';

const ManageTeamRoutes = (): any => ({
  path: 'manage-team',
  element: <ManageTeamWrapper />,
  children: [
    {
      path: '',
      element: <ManageTeam />,
    },
  ],
});

export default ManageTeamRoutes;
